import { render } from "./XiaofeiData.vue?vue&type=template&id=1882a63a&scoped=true"
import script from "./XiaofeiData.vue?vue&type=script&lang=js"
export * from "./XiaofeiData.vue?vue&type=script&lang=js"

import "./XiaofeiData.vue?vue&type=style&index=0&id=1882a63a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-1882a63a"

export default script